const messages = {
  topbar: {
    kolobrzeg: 'Kołobrzeg',
    back: 'Back',
    favourites: 'Favourites',
    chooseFloorOrFlat: 'Choose floor or flat',
    chooseFloor: 'Choose floor',
    chooseFlat: 'Choose flat',
    chooseBuilding: 'Choose building',
    chooseInvestment: 'Choose investment',
    filtering: 'Filtering',
  },
  flat: 'Flat',
  floor: 'Floor',
  building: 'Building',
  groundFloorShortcut: 'GF',
  tooltip: {
    flatNumber: 'Number of flats',
    available: 'Available',
    booked: 'Booked',
    sold: 'Sold',
  },
  singleBuilding: {
    loading: 'Loading 3D module',
  },
  singleFlat: {
    area: 'Area',
    floor: 'Floor',
    groundFloor: 'Ground floor',
    rooms: 'Rooms',
    price: 'Price',
    status: 'Status',
    num: 'No.',

    noPrev: 'No preview',
    similar: 'Similar Flats',
    askPrice: 'Ask for price',
    closeForm: 'Close the form',
    downloadPDF: 'Download PDF',
  },
  form: {
    title: 'Ask for flat',
    name: 'Name',
    name_error: 'Please enter your name',
    email: 'E-mail',
    email_error: 'Please enter email',
    phone: 'Phone',
    phone_error: 'Please enter phone number',
    message: 'Message',
    message_error: 'Please write a message',
    check_error: 'Please check the checkbox',
    submit: 'Ask for flat',
    sent: 'Sent',
  },
  filters: {
    criteria: 'Meet the criteria',
    remove: 'Remove filters',
    amenities: 'Amenities',
    balcony: 'Balcony',
    garden: 'Garden',
    search: 'Search for',
  },
  favourites: {
    noCriteria: 'There is no flat that meet your criteria',
    noFavs: 'No favourites flats',
    placeholder: 'Type name...',
    sortBy: 'Sort by',
    sorting: 'Choose sorting',
    openSort: 'Sorting options',
    findFlat: 'Find a flat',
    ascending: 'ascending',
    descending: 'descending',
    flatsIn: 'Favourite flats',
    delete: 'Remove all',
  },
  pageNotFound: 'Page not found',
  homepage: 'Go back to homepage',
  loadingFlats: 'Loading flats',
  from: 'from',
  to: 'to',
  surface: 'Area',
  rooms: 'Rooms',

  agreeInfoShort: `The personal data controller is Vacation Investments Sp. z o.o. with its registered office at ul. Kościuszki 16 in Kołobrzeg...`,
  agreeInfo: `The personal data controller is Vacation Investments Sp. z o.o. with its registered office at ul. Kościuszki 16 in Kołobrzeg. You have the right to access your personal data and to delete and correct them, restrict the processing and withdraw the consent to the processing. The provision of personal data is voluntary. By sending the form you give your consent to their processing. Your data will be processed for marketing purposes, inter alia, using automated profiling. The legal basis for the processing of your personal data is provided by Article 6(1)(a) of GDPR, i.e. the consent, if granted, or Article 6(1)(f) of GDPR (legitimate interests pursued by the controller, direct marketing). The scope of the processed personal data: last name, first name, function, telephone number, e-mail address. The data will be stored until you submit an objection. You can contact the data controller by email: marketing@hotelbalticwave.pl, by phone +48 882 784 606, and by mail to the specified address of the seat. To whom do we provide your data? We can provide your data to: 1. entities authorized to receive them on the basis of the provisions of law, e.g. courts, regulatory authorities, legal protection entities; 2. entities processing your data on our behalf, i.e. advertising agencies, entities operating our ICT systems or providing us with ICT tools, research companies, entities providing advisory and consulting services etc.); 3. other entities with capital or management links, to pursue the controller’s legitimate interests.`,
  agree1Short: `I hereby give my consent to receive marketing and commercial information...`,
  agree1: `I hereby give my consent to receive marketing and commercial information from Vacation Investments Sp. z o.o. to the e-mail address I provided.`,
  agree2Short: `I hereby give my consent to receive marketing and commercial information...`,
  agree2: `I hereby give my consent to receive marketing and commercial information from Vacation Investments Sp. z o.o. to the telephone number I provided.`,
  agree3Short: `I hereby give my consent to Vacation Investments Sp. z o.o. to process...`,
  agree3: `I hereby give my consent to Vacation Investments Sp. z o.o. to process my personal data for marketing of products and services offered by Vacation Investments Sp. z o.o.`,
  cardsView: 'Cards',
  listView: 'List',
  apartment: 'Apartment',
  addToFavs: 'Add to favourites',
  removeFromFavs: 'Remove from favourites',
  loadMore: 'Load more',
  matchingFlatsInfo: 'Flats satisfying your criteria',
};

export default messages;
